import swal from "sweetalert";

const Alert = (title, text, icon, buttonText) => {
    return swal({
        title,
        text,
        icon,
        button: buttonText || "متوجه شدم"
    });
}

export default Alert;